import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as _ from 'lodash';
import { catchError, map, switchMap } from 'rxjs/operators';
import { PasswordCreateActions } from '../actions';
import { OnboardingProductsService } from '../../services/onboarding-products.service';
import { Common } from './common';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import { OnboardingProductsStore } from '../store';

@Injectable()
export class PasswordCreateEffects {
  constructor(
    private actions$: Actions,
    private onboardingProductsService: OnboardingProductsService,
    private store: Store<OnboardingProductsStore.AppState>
  ) {}

  private common = new Common();

  getPasswordCreate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PasswordCreateActions.getPasswordCreate),
      switchMap((action) =>
        this.onboardingProductsService.getPasswordCreate(action.request).pipe(
          map((res) => this.common.responseInterpreter(res)),
          map((res) => res['middleware']),
          map((res) => PasswordCreateActions.getPasswordCreateSucess({ response: res })),
          catchError((error) =>
            of(
                PasswordCreateActions.getPasswordCreateError({
                payload: this.common.handleErrorsDefault(error)
              })
            )
          )
        )
      )
    )
  );

  responseInterpreter(res) {
    res = res['response'];
    const response = res;
    console.log('EL MIDDLEWARE DEL PASSWORDCREATE ES: ', response['middleware']);
    if (
      _.get(res, 'status.code', '') === 200 ||
      _.get(res, 'status.code', '') === 202
    ) {
      if (_.get(res, 'middleware', null)) {
        response['middleware'] = _.get(res, 'middleware', null);
      }
    }
    console.log('EL MIDDLEWARE DEL PASSWORDCREATE DESPUES: ', response['middleware']);
    console.log('******** ResponseInterpreter Return', response);
    return response;
  }

  /* responseInterpreter(res) {
    console.log('******** ResponseInterpreter Input', res);
    const response = res;

    if (
      _.get(res, 'status', '') === 200 ||
      _.get(res, 'status', '') === 201
    ) {
      if (_.get(res, 'data', null)) {
        response['data'] = _.get(res, 'data', null);
      }
    }
    console.log('******** ResponseInterpreter Return', response);
    return response;
  } */
}
